'use client'

import { useAuth0 } from '@auth0/auth0-react'
import { useRouter } from 'next/navigation'
import { useContext, useEffect } from 'react'

import { useMyself } from '@/api/users'
import { APP_PATHS } from '@/global/consts'
import { analytics } from '@/services/analytics'

import { ClientProviders } from './ClientProviders'
import { AuthRedirectContext } from './providers/authentication/Auth0ProviderWithHistory'

const Redirect = () => {
  const router = useRouter()
  const { isAuthenticated } = useAuth0()
  const { data: myself } = useMyself()
  const { email, name, api_key, id: userId } = myself ?? {}
  const { redirectUrl } = useContext(AuthRedirectContext) ?? {}

  useEffect(() => {
    if (isAuthenticated) {
      analytics.identify(userId, { email, name, api_key })
    }
  }, [isAuthenticated, userId, email, name, api_key])

  useEffect(() => {
    // We redirect to the URL stored in the context set by Auth0ProviderWithHistory
    // to make sure this redirect will not override the redirect done there if it occurs.
    router.push(redirectUrl?.current ?? APP_PATHS.DEFAULT)
  }, [router, redirectUrl])

  return null
}

const FirstLandingPage = () => {
  return (
    // ClientProviders will render the LandingPage if not authenticated
    <ClientProviders>
      {/* Redirect will render if authenticated then redirect to Projects page */}
      <Redirect />
    </ClientProviders>
  )
}

export default FirstLandingPage
